module.exports = __webpack_public_path__ + "media/images/story-marker-0d17546c.png";